export const EDIT_PROFILE = "EDIT_PROFILE"
export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";
export const UPDATE_PHONE_NUMBER = "UPDATE_PHONE_NUMBER";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_USER_PROFILE_PICTURE = "UPDATE_USER_PROFILE_PICTURE";
export const UPDATE_USER_PROFILE_PICTURE_SUCCESS = "UPDATE_USER_PROFILE_PICTURE_SUCCESS";
export const UPDATE_USER_PROFILE_PICTURE_ERROR = "UPDATE_USER_PROFILE_PICTURE_ERROR";
export const UPDATE_TWO_FACTOR_AUTH = "UPDATE_TWO_FACTOR_AUTH";
export const UPDATE_TWO_FACTOR_AUTH_SUCCESS = "UPDATE_TWO_FACTOR_AUTH_SUCCESS";
export const UPDATE_TWO_FACTOR_AUTH_ERROR = "UPDATE_TWO_FACTOR_AUTH_ERROR";
export const UPDATE_ORG_LOGO = "UPDATE_ORG_LOGO"
export const UPDATE_ORG_LOGO_SUCCESS = "UPDATE_ORG_LOGO_SUCCESS";
export const UPDATE_ORG_LOGO_FAIL = "UPDATE_ORG_LOGO_FAIL";